export default __webpack_public_path__ + "static/media/tab_6.0b70d26e.svg";